import * as models from "./api/models";

export default function isAddressKey(key: string): key is models.AddressKeys {
    return !!Object.values(models.AddressKeys).find((addressKey) => addressKey === key);
}
